<template>
  <div>
    <div id="contact"
      style="margin-top: 46px"
      class="contact w-full z-10 bg-white border-l hidden lg:block px-3 fixed h-full"
    >
      <span @click="toggleContactPage" class="text-sm cursor-pointer mt-5 font-mono contact-span">Contact Me</span>
      <button @click="toggleContactPage"
        class="absolute right-14 top-14 border rounded-full px-4 py-2 flex items-center justify-center"
      >
        X
      </button>
      <div class="font-mono px-16">
        <h1 class="text-4xl">Have a Project? Lets talk!</h1>

        <form id="contact-form"  action="https://formspree.io/f/meqpvjnb" method="POST" class="mt-8 w-4/6 space-y-6">
          <input name="name"
            class="w-full text-lg border py-2 px-2"
            placeholder="Your Name"
            type="text"
          />
          <input name="_replyto"
            class="w-full text-lg border py-2 px-2"
            placeholder="Email"
            type="email"
          />
          <textarea name="message"
            class="w-full text-lg border py-2 px-2"
            placeholder="Message Here"
            type="text"
            cols="24"
            rows="8"
          ></textarea>
          <div class="flex w-full flex-row-reverse mt-6">
            <button type="submit"
              class="bg-white border w-full uppercase md:w-auto text-center border-gray-400 hover:bg-gray-100 text-xs px-12 py-3 text-md"
              href="#"
              >Send</button
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineMax, gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(CSSPlugin);
export default {
  data() {
    return {
      t1: new TimelineMax({ paused: true }),
      current: "closed"
    };
  },
  mounted() {
    this.t1.to(
      "#contact",
      0.8,
      {
        xPercent: -97
      },
    );
    this.t1.reverse()
  },
  methods: {
      toggleContactPage() {
          this.t1.reversed(!this.t1.reversed());
          document.getElementById("contact-form").reset()
      },
  }
};
</script>

<style>
.contact-span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
#contact {
  top: 2px;
  right: -97%;
}
</style>